import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

// styles
import styles from './styles.module.scss'

// api
import { InstitutionRepository } from '../../admin/repositories/institution.repository'

//components
import { Header } from '@/components/Header'
import { Statusbar } from '../../../components/Statusbar'
import { TitleFormStudents } from '../../../components/TitleForm'
import { FooterButtons } from '../../../components/FooterButtons'

// utils
import { formatMoney } from '../../../utils/formatting/money'
import { Institution } from '@/domain/entities/institution.entity'
import { StorageService } from '@/services/storage'
import { useDownload } from '@/pages/@hooks/use-download'
import { Scholar } from '@/Icons'
import { Course } from '@/domain/entities/course.entity'

const storageService = new StorageService()

export function StudentsFormOne() {
  const navigate = useNavigate()
  const { course_id } = useParams()
  const [image, setImage] = useState('')
  const [hasError, setHasError] = useState(false)
  const [course, setCourse] = useState({} as Course)
  const [institute, setInstitute] = useState({} as Institution)

  const { download } = useDownload({ storageService })

  const downloadImage = useCallback(async () => {
    const [{ url }] = await download(institute?.logo)
    setHasError(false)
    setImage(url)
  }, [institute?.logo])

  useEffect(() => {
    downloadImage()
  }, [downloadImage])

  useEffect(() => {
    const fetchCurso = async () => {
      const { course } = await InstitutionRepository.GetInstance().getCursoById(
        Number(course_id),
      )
      setInstitute(course.Institution)
      setCourse({
        ...course,
        amount: formatMoney(course.amount),
        promotional_value: formatMoney(course.promotional_value),
        percent: `${course.percent}%`,
      })
    }
    fetchCurso()
  }, [course_id])

  const handleRedirectNextPage = () => {
    navigate(`/register-student/${course_id}/step-2`)
  }

  return (
    <>
      <Header />
      <div className={styles.container_form}>
        <Statusbar step="step_1" />
        <span>Etapa 1 de 4</span>
        <div className={styles.content_form}>
          <TitleFormStudents title="Revise sua escolha" />

          <div className={styles.container_institute}>
            <div className={styles.image}>
              <img
                height={400}
                width={400}
                src={image}
                onError={(e) => {
                  const target = e.currentTarget
                  target.onerror = null
                  target.src = '/default_logo.png'
                }}
              />
              {hasError && <Scholar size={400} />}
            </div>

            <div className={styles.course_information}>
              <strong>Curso</strong>
              <span>{course?.name}</span>
              <strong>Ano</strong>
              <span>{course?.scholarship_year}</span>
              <strong>Instituição</strong>
              <span>{institute?.title}</span>
              <strong>Valor</strong>
              <span>{course?.amount}</span>
              <strong>Desconto</strong>
              <span>{course?.percent}</span>
              <strong>Valor com desconto</strong>
              <span>{course?.promotional_value}</span>
            </div>
          </div>

          <FooterButtons
            redirectLink={`/`}
            handleClick={handleRedirectNextPage}
            type="button"
          />
        </div>
      </div>
    </>
  )
}
